import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { isMobile } from 'react-device-detect';

import { UploadDocumentsDrawerStyled } from '../UploadDocumentsDrawer/UploadDocumentsDrawerStyled';
import { ViewDocumentDetailsDrawerCardStyled } from '../ViewDocumentDetailsDrawer/ViewDocumentDetailsDrawerStyled';
import { base64ToBlobURL } from 'enrollment/utils/FileUtils/base64blob';

export interface DocumentPreviewDrawerProps {
  openDrawer?: boolean;
  setOpenDrawer?: any;
  documentRequestId?: number;
  contentType?: string;
  fileData?: string;
}

export const DocumentPreviewDrawer = ({
  openDrawer,
  setOpenDrawer,
  documentRequestId,
  contentType,
  fileData,
}: DocumentPreviewDrawerProps) => {
  const { t } = useTranslation('pages.addYourDocuments');
  const [blobUrl, setBlobUrl] = useState<string>('');

  const handleCloseDrawer = () => {
    setOpenDrawer(false);
  };

  useEffect(() => {
    if (contentType?.includes('/pdf')) {
      const blob = base64ToBlobURL(fileData, contentType as any);
      const blobUrl = URL.createObjectURL(blob as any);

      setBlobUrl(blobUrl);
    }
  }, [contentType, fileData]);

  return (
    <>
      <UploadDocumentsDrawerStyled
        open={openDrawer}
        anchor="right"
        id={`view-details-drawer-${documentRequestId}`}
        data-testid={`view-details-drawer-${documentRequestId}`}
        onClose={handleCloseDrawer}
      >
        <ps-button
          id={`back-button-${documentRequestId}`}
          label={isMobile ? t('common:back') : t('common:close')}
          level="tertiary"
          icon={isMobile ? 'caret-left' : 'x'}
          onClick={handleCloseDrawer}
          extraClass="p-0 my-3"
        />
        <>
          {contentType?.includes('image/') ? (
            <ViewDocumentDetailsDrawerCardStyled>
              <img
                src={`data:${contentType};base64,${fileData}`}
                alt="document_image"
                className="w-100 h-100"
              />
            </ViewDocumentDetailsDrawerCardStyled>
          ) : (
            <embed src={blobUrl} className="w-100 h-100" />
          )}
        </>
      </UploadDocumentsDrawerStyled>
    </>
  );
};
